import script from "./remote-login-log-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./remote-login-log-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__